import { render, staticRenderFns } from "./CreateCertificate.vue?vue&type=template&id=11225687&scoped=true"
import script from "./CreateCertificate.vue?vue&type=script&lang=js"
export * from "./CreateCertificate.vue?vue&type=script&lang=js"
import style0 from "./CreateCertificate.vue?vue&type=style&index=0&id=11225687&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11225687",
  null
  
)

export default component.exports